export default __webpack_public_path__ + "static/sticker-skeptic-bfaa6014fc66bc2f5b3af930d3ec9993.svg";